
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/sprig",
      function () {
        return require("private-next-pages/destinations/sprig.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/sprig"])
      });
    }
  